import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export interface AgenteChatConvRow {
  id: string;
  utente: string;
  email: string | null;
  n_messaggi: number;
  ultimo_messaggio_il: string | null;
}

export interface AgenteChatPasso {
  nome: string;
  args: Record<string, unknown> | null;
  esito: string;
}

export interface AgenteChatMessaggio {
  id: string;
  ruolo: "utente" | "aida";
  testo: string | null;
  passi: AgenteChatPasso[];
  creato_il: string;
}

export interface AgenteChatTranscript {
  id: string;
  messaggi: AgenteChatMessaggio[];
  costo_usd: number;
  token_input: number;
  token_output: number;
}

export function useAgenteChatConversazioni() {
  return useQuery({
    queryKey: ["admin", "agente-chat", "conversazioni"],
    queryFn: () =>
      apiFetch<{ conversazioni: AgenteChatConvRow[] }>(
        "/api/v1/m3/agente/chat/admin/conversazioni",
      ),
  });
}

export function useAgenteChatTranscript(id: string | null) {
  return useQuery({
    queryKey: ["admin", "agente-chat", "transcript", id],
    queryFn: () =>
      apiFetch<AgenteChatTranscript>(
        `/api/v1/m3/agente/chat/admin/conversazioni/${id}`,
      ),
    enabled: !!id,
  });
}
